import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {Router} from '@angular/router';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import {BaseEffect} from './base.effect';
import {error} from '..';
import {LoadServerByTypeAction, LoadServerFailAction, LoadServerSuccessAction, serverActionTypes} from '../actions/servers';
import {ArrayResponse, SendBackResult} from '..';
import {ServerForm} from '../models/servers';
import {ServersService} from '../services/servers.service';
import {L10nTranslationService} from 'angular-l10n';
import {AssignPlayerAction} from '../../order/actions/assign-player';

@Injectable()
export class ServerEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(serverActionTypes.LOAD),
      debug('Server load action received.'),
      withLatestFrom(this.store.pipe(
        select(fromRoot.selectors.getCurrentClient),
        filter(client => !_.isEmpty(client))
      )),
      switchMap( ([action, client]) => this.serversService.getServers(client.uuid).pipe(
        map((resp: SendBackResult<ArrayResponse<ServerForm>>) => resp.data.array.map(server => {
          // tslint:disable-next-line:radix
          return  { name: server.name + (server.ip ? ' (' + server.ip + ')' : ''), id: server.id, url: parseInt(server.url), ip: server.ip}
        })),
        map((servers: ServerForm[]) => new LoadServerSuccessAction(servers))
  )))
  });
  loadByType$ = createEffect(() => { return this.actions$.pipe(ofType(serverActionTypes.LOAD_BY_TYPE),
    debug('Server load action received.'),
    map((action: LoadServerByTypeAction) => action.payload),
    withLatestFrom(this.store.pipe(
      select(fromRoot.selectors.getCurrentClient),
      filter(client => !_.isEmpty(client))
    )),
    switchMap( ([action, client]) => this.serversService.getServersByType(client.uuid , action).pipe(
      map((resp: SendBackResult<ArrayResponse<ServerForm>>) => resp.data.array.map(server => {
        // tslint:disable-next-line:radix
        return  { name: server.name + (server.ip ? ' (' + server.ip + ')' : ''), id: server.id, url: parseInt(server.url), ip: server.ip}
      })),
      map((servers: ServerForm[]) => new LoadServerSuccessAction(servers))
    )))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(serverActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Server list.'),
    map((action: LoadServerFailAction) =>
      error(this.translation.translate('SERVER_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  protected handleUnhandledError = (response) => {
    return new LoadServerFailAction(response['error'].message); }

  protected handleGoneError = (response) => {
    return new LoadServerFailAction(response['error'].message);
  }

  constructor(router: Router,
              private actions$: Actions,
              private store: Store<fromRoot.AppState>,
              private translation: L10nTranslationService,
              private serversService: ServersService) {
  super(router);
  }
}
